import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_HelpDialog = _resolveComponent("HelpDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-3 p-mx-2" }, {
      start: _withCtx(() => [
        (!_ctx.expandTableCard)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-chevron-right",
              class: "p-button-text p-button-rounded p-button-plain",
              style: {"color":"white"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandTableCard = true))
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-chevron-down",
              class: "p-button-text p-button-rounded p-button-plain",
              style: {"color":"white"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandTableCard = false))
            })),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.datasetManagement.jsonPathAttributes')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "fas fa-plus",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.addNewParam
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "fas fa-info-circle",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.helpDialogVisible = true))
        }),
        _createVNode(_component_Button, {
          icon: "fas fa-eraser",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.disableDeleteAll,
          onClick: _ctx.removeAllParams
        }, null, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_Card, { class: "p-mx-2" }, {
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm kn-table",
          editMode: "cell",
          value: _ctx.dataset.restJsonPathAttributes,
          scrollable: true,
          scrollHeight: "250px",
          dataKey: "versNum",
          responsiveLayout: "stack",
          breakpoint: "960px",
          onCellEditComplete: _ctx.onCellEditComplete
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.tableEmpty')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "name",
              header: _ctx.$t('kpi.alert.name'),
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  modelValue: data.name,
                  "onUpdate:modelValue": ($event: any) => (data.name = $event)
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "jsonPathValue",
              header: _ctx.$t('managers.datasetManagement.jsonPathValue'),
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  modelValue: data.jsonPathValue,
                  "onUpdate:modelValue": ($event: any) => (data.jsonPathValue = $event)
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "typeOrJsonPathValue",
              header: _ctx.$t('managers.datasetManagement.typeOrJsonPathValue'),
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Dropdown, {
                  id: "scope",
                  modelValue: data.jsonPathType,
                  "onUpdate:modelValue": ($event: any) => (data.jsonPathType = $event),
                  class: "kn-material-input kn-small-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  options: _ctx.jsonPathTypes,
                  "option-label": "label",
                  "option-value": "type"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "style", "options"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { onRowClick: false }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteParam(slotProps))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onCellEditComplete"])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.expandTableCard]
    ]),
    _createVNode(_component_HelpDialog, {
      visible: _ctx.helpDialogVisible,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.helpDialogVisible = false))
    }, null, 8, ["visible"])
  ], 64))
}